"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsPopover = void 0;
const React = __importStar(require("react"));
const AbstractHelpPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/AbstractHelpPopover");
const constants_1 = require("src/hello_assets/src/constants");
const EventsPopover = () => {
    const content = React.createElement("div", { style: { width: "500px" } },
        React.createElement("p", null, "This section shows unique users who perform given events on a daily basis."),
        React.createElement("p", null,
            "NOTE: events are available starting from ",
            React.createElement("a", { href: constants_1.URL_GITHUB, target: "_blank" }, "SDK version 1.0.3")));
    return React.createElement(AbstractHelpPopover_1.AbstractHelpPopover, { title: "Events", content: content });
};
exports.EventsPopover = EventsPopover;
